"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RechargeRequest = void 0;
var RechargeRequest = /** @class */ (function () {
    function RechargeRequest() {
    }
    return RechargeRequest;
}());
exports.RechargeRequest = RechargeRequest;
;
//# sourceMappingURL=recharge.request.js.map